module.exports = __webpack_public_path__ + "img/people.411fe889.svg";